import { render, staticRenderFns } from "./ExtensionSelectorModal.vue?vue&type=template&id=0cd973f4&scoped=true&"
import script from "./ExtensionSelectorModal.vue?vue&type=script&lang=js&"
export * from "./ExtensionSelectorModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cd973f4",
  null
  
)

export default component.exports